export class AggregatedLogSearchParameters {
    constructor(
        public includeVerbose: boolean,
        public includeInfo: boolean,
        public includeWarning: boolean,
        public includeError: boolean,
        public includeClear: boolean,
        public measuringPointIds: number[],
        public scenarioIds: number[],
        public from?: Date,
        public until?: Date,
    ) {}
}
